/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : 管理js-bridge
 */
// =================================================================
import { constConf } from '@GLOBAL/constConf'
import { getQueryString } from '@ywxk/util/url'
import { localCache, cookies } from '@ywxk/util/localCache'
import JsBridge from '@ywxk/js-bridge'
import { client } from '@UTILS/client'

const { API_URL, IS_DEBUG, PROJECT, IS_PROD, IS_GRAY } = constConf
interface AppData {
  key: String
  shortlink_host: String
  id: Number
  id2: Number
  [prop: string]: unknown
}

interface GetKeyOpt {
  timeout: number | null
  isApp: Boolean
  isPc: Boolean
}

let key = getQueryString('key') || localCache.getItem('_key_') || cookies.getItem('loginKey') || cookies.getItem(`${PROJECT}_loginKey`) || null
let apiUrl = API_URL
let appData: AppData
let bridgeClient = new Proxy(
  {},
  {
    get(source, propKey) {
      if (propKey === 'isUnInit') return true
      if (source[propKey]) {
        return source[propKey]
      } else {
        console.error(`没定义${propKey}方法或者尚未初始化完成`)
        return () => {}
      }
    },
  }
)
function initBridgeClient(isApp: boolean, isPc: boolean) {
  if (!bridgeClient.isUnInit) return
  window.jsBridgeClient = bridgeClient = new JsBridge({
    isDebug: IS_DEBUG,
    isPc,
    isApp,
    isFlutter: client.isFlutter,
  })
}

/**
 * 初始化获取key
 * @params { Number } timeout, 超时时间,可选
 * returns { Promise }
 */
let getKeyTimer: number | null = null
const getKey = function (opt: GetKeyOpt) {
  // 合并参数
  opt = Object.assign({ timeout: null }, opt)
  const { timeout, isApp, isPc } = opt
  // 判断环境
  if (isApp || isPc) {
    return new Promise((resolve, reject) => {
      // 过时判断登录失败,因为本地是走错误流程,定时器不适合太长
      if (timeout) {
        getKeyTimer = window.setTimeout(function () {
          if (key) {
            return getKeyDone(key)
          } else {
            reject(`获取账号信息失败-${PROJECT}`)
          }
        }, timeout)
      }

      // 清理定时器
      const getKeyDone = (key) => {
        timeout && clearTimeout(Number(getKeyTimer))
        getKeyTimer = null
        return resolve(key)
      }
      initBridgeClient(isApp, isPc)

      bridgeClient.initData(null, (res) => {
        IS_DEBUG && logConf()
        appData = res
        //临时兼容pc,后期要还原
        if (client.isOxygenPC && (IS_PROD || IS_GRAY)) {
          apiUrl = apiUrl
        } else {
          apiUrl = res.shortlink_host || apiUrl
        }
        key = res.key
        if(!key) {
          reject(`获取账号信息失败（回调错误,空key）-${PROJECT}`)
        }

        return getKeyDone(res.key)
      })
      // 加载桥接之后回调
      afterLoadJsbridge();
    })
  } else {
    return Promise.reject('当前环境不在客户端!')
  }
}

// 移除指定安卓本地缓存
function afterLoadJsbridge() {
  const cacheKey = 'ywxk_android_cache'
  const cacheUrl = localCache.getItem(cacheKey)
  if (cacheUrl && bridgeClient.deleteDiscCache) {
    localCache.removeItem(cacheKey)
    const cacheUrls = [cacheUrl]
    const cachePath = cacheUrl.split('#')?.[0] ?? ''
    if (cachePath !== '') {
      cacheUrls.push(cachePath)
      cacheUrls.push(`${cachePath}#/`)
    }
    // 记录的可能是重定向之后的地址,安全起见同时删除两份
    bridgeClient.deleteDiscCache({ cacheUrls })
  }
}

function logConf() {
  // 延迟等到控制台初始化输出
  setTimeout(() => {
    console.info('appData: ', appData)
  }, 3000)
}

// 留个口子给站外登录的页面
const setKey = function (token: string) {
  key = token
}

export { key, apiUrl, setKey, getKey, appData, bridgeClient, initBridgeClient }
